const DIRTY_FIELD_TTL_MS = 5 * 60 * 1000;

export const dirtyItemTypes = {
  SECTION: "section",
  SHEET: "sheet",
  CUSTODIAN: "custodian"
};

const dirtyFieldTsByItemType = new Map();
let lastSweepTs = null;

// getDirtyProperties only prunes the entry it reads, so entries for items that are never read
// again (e.g. deleted while dirty) would linger; a periodic full sweep on write keeps the
// registry bounded without a timer.
const sweepExpiredDirtyFields = () => {
  for (const [itemType, dirtyFieldTsById] of dirtyFieldTsByItemType) {
    for (const [id, fieldTsMap] of dirtyFieldTsById) {
      for (const [property, ts] of Object.entries(fieldTsMap)) {
        if (Date.now() - ts >= DIRTY_FIELD_TTL_MS) {
          delete fieldTsMap[property];
        }
      }
      if (Object.keys(fieldTsMap).length === 0) {
        dirtyFieldTsById.delete(id);
      }
    }
    if (dirtyFieldTsById.size === 0) {
      dirtyFieldTsByItemType.delete(itemType);
    }
  }
};

export const markDirtyField = (itemType, id, property) => {
  if (!lastSweepTs === true) {
    lastSweepTs = Date.now();
  } else if (Date.now() - lastSweepTs >= DIRTY_FIELD_TTL_MS) {
    sweepExpiredDirtyFields();
    lastSweepTs = Date.now();
  }
  const dirtyFieldTsById = dirtyFieldTsByItemType.get(itemType) || new Map();
  const fieldTsMap = dirtyFieldTsById.get(id) || {};
  fieldTsMap[property] = Date.now();
  dirtyFieldTsById.set(id, fieldTsMap);
  dirtyFieldTsByItemType.set(itemType, dirtyFieldTsById);
};

export const getDirtyItemIds = itemType => {
  const dirtyFieldTsById = dirtyFieldTsByItemType.get(itemType);
  return !dirtyFieldTsById === true ? [] : Array.from(dirtyFieldTsById.keys());
};

// A field stays dirty for DIRTY_FIELD_TTL_MS after its last local edit. Until the edit's
// queued save reaches the server, any fetch response — whether issued before or after the
// edit — can still carry the stale value; the TTL is long enough for the save and all such
// responses to settle. Expired entries are pruned lazily on read, so no timer is needed.
export const getDirtyProperties = (itemType, id) => {
  const dirtyFieldTsById = dirtyFieldTsByItemType.get(itemType);
  if (!dirtyFieldTsById === true) {
    return [];
  }
  const fieldTsMap = dirtyFieldTsById.get(id);
  if (!fieldTsMap === true) {
    return [];
  }
  const dirtyProperties = [];
  for (const [property, ts] of Object.entries(fieldTsMap)) {
    if (Date.now() - ts < DIRTY_FIELD_TTL_MS) {
      dirtyProperties.push(property);
    } else {
      delete fieldTsMap[property];
    }
  }
  if (Object.keys(fieldTsMap).length === 0) {
    dirtyFieldTsById.delete(id);
    if (dirtyFieldTsById.size === 0) {
      dirtyFieldTsByItemType.delete(itemType);
    }
  }
  return dirtyProperties;
};
